import { ClassifiedBucketType } from '~/models/classified/types'
import { ParkingTab, ParkingRecent } from '~/models/parking'
import { SearchOfBucket, Pagination } from '~/models/search/types'
import { ClassifiedList } from '~/models/classified-list/types'
import { ParkingClassifieds } from '~/models/classified/parking/types'

export const PARKING_NS = 'parking'

type ClassifiedId = number

export interface ParkingState {
  groups: ParkingClassifieds
  bucket: ClassifiedBucketType | null
  error: boolean
  searches: SearchOfBucket[] | null
  recent: ParkingRecent | null
  classifiedLists: ClassifiedList[]
  classifiedsPagination: Pagination
  loading: boolean
  classifiedListLoading: boolean
  classifiedListActionButtonsLoading: boolean
  activeTab: ParkingTab
  classifiedsList: any[] | null // TODO: Type this array, it's assigned in the fetch_classifieds_list parking action.
  compareList: ClassifiedId[] | null
  classifiedOrder: ClassifiedId[]
  notificationClassifieds: ClassifiedId[]
  selectedList: ClassifiedList | null
  showParking: boolean
  parkUrlBefore: string | null
  parkingNotifications: number
  swipeDirection: 'swipe-left' | 'swipe-right' | null
  selectedCategory?: number
}

function getDefaultState(): ParkingState {
  return {
    groups: {
      classifieds: {
        pagination: { page: 1, total: 0, pageParam: 'pg', perPage: 24 },
        rows: []
      },
      filters: { categories: [] },
      sortOptions: []
    },
    bucket: null,
    error: false,
    searches: null,
    recent: null,
    classifiedLists: [],
    classifiedsPagination: { page: 1, total: 0, pageParam: 'pg', perPage: 24 },
    loading: true,
    classifiedListLoading: false,
    classifiedListActionButtonsLoading: false,
    activeTab: 'classifieds',
    classifiedsList: null,
    compareList: [],
    classifiedOrder: [],
    notificationClassifieds: [],
    selectedList: null,
    showParking: false,
    parkUrlBefore: null,
    parkingNotifications: 0,
    swipeDirection: null,
    selectedCategory: 0
  }
}
export default getDefaultState
